"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Wrench = function (_a) {
    var fill = _a.fill, props = __rest(_a, ["fill"]);
    return (React.createElement("svg", __assign({ fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.026 3.623a5.387 5.387 0 0 0-5.672 7.891.77.77 0 0 1-.163.968l-6.22 5.372a1.538 1.538 0 0 0 2.175 2.175l5.373-6.22a.77.77 0 0 1 .97-.16 5.387 5.387 0 0 0 7.888-5.675L17.252 11.1a.77.77 0 0 1-.695.21l-2.72-.544a.77.77 0 0 1-.603-.603l-.544-2.72a.77.77 0 0 1 .21-.695l3.126-3.125zm-3.732 11.642a6.926 6.926 0 0 0 9.157-9.044.77.77 0 0 0-1.252-.244L16.455 9.72l-1.813-.363-.363-1.813L18.023 3.8a.767.767 0 0 0 .17-.831.77.77 0 0 0-.414-.421 6.925 6.925 0 0 0-9.044 9.157L2.94 16.71a3.077 3.077 0 1 0 4.349 4.349l5.004-5.794z", fill: fill || 'currentColor' })));
};
exports.default = Wrench;
